import script from "./AUploadMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./AUploadMultiple.vue?vue&type=script&setup=true&lang=js"

import "./AUploadMultiple.vue?vue&type=style&index=0&id=3e0f0072&lang=css"

const __exports__ = script;

export default __exports__